export enum ColdEmailPlanName {
  Starter = 'Starter',
  Professional = 'Pro',
  Business = 'Scale',
  ScalePlus = 'Scale Plus',
  Custom = 'Custom',
}

export type IProps = {
  planName: ColdEmailPlanName;
  description: string;
  price?: number;
  features: { feature: string; tooltipText?: string }[];
  headerImage: string;
  isBestValuePlan: boolean;
  handlePlanSelect: VoidFunction;
};
